import { Maximize2, Minimize2 } from 'lucide-react'
import { Button } from '../Button'

export interface FullscreenButtonProps {
  fullscreen: boolean
  onToggle: () => void
  /** Override the default hover tooltip. */
  title?: string
}

const DEFAULT_OFF_TITLE =
  'Fullscreen — hides sidebar/topbar for wide-table exploration (Esc to exit)'
const DEFAULT_ON_TITLE = 'Exit fullscreen (Esc)'

export function FullscreenButton({
  fullscreen,
  onToggle,
  title,
}: FullscreenButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      iconOnly
      aria-label={fullscreen ? 'Exit fullscreen' : 'Fullscreen'}
      title={title ?? (fullscreen ? DEFAULT_ON_TITLE : DEFAULT_OFF_TITLE)}
      onClick={onToggle}
    >
      {fullscreen ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
    </Button>
  )
}
